module.exports = __webpack_public_path__ + "static/media/shdocvw_256.7203a8dd.ico";